import {NgModule} from "@angular/core";
import {AclForm} from "./acl.service";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {TableModule} from "primeng/table";
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';

@NgModule({
    declarations: [
        AclForm
    ],
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        ButtonModule,
        DropdownModule,
        DialogModule,
        TableModule
    ],
    exports: [
        AclForm
    ]
})
export class AclModule {}
